export enum FeatureType {
    Size = 'size',
    Color = 'color',
    BoardType = 'boardType',
    LineLength = 'lineLength',
}